module.exports = __webpack_public_path__ + "img/9788952228611.77e4818a.jpg";